module.exports = __webpack_public_path__ + "img/15.355c5bc0.png";